import { Injectable } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
@Injectable({
  providedIn: 'root',
})
export class UserPermissionService {
  constructor(
    private permissionsService: NgxPermissionsService
  ) { }

  perms: any[] = [];
  is_superuser: any;
  currentUser: any;

  loadPermission(callApi = false) {
    const user = localStorage.getItem('user');
    this.is_superuser = JSON.parse(localStorage.getItem('user') || '')?.is_superuser;
    let permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
    // if (this.is_superuser) {
    //   permissions.push('is_superuser')
    // }

    if (user) {
      this.currentUser = JSON.parse(user);
    }

    if (permissions) {
      this.permissionsService.loadPermissions(permissions);
      this.perms = permissions
    }
  }

  returnPerms() {
    return this.perms;
  }
}



